import { flow } from 'fp-ts/function';
import { keyBy as keyByLodash, mapValues } from 'lodash';
import { flatMap, get, keyBy, map } from 'lodash/fp';

import { Day } from '@mews/enums';

export const prepareGlobalization = ({
    countries,
    cultureInfos,
    currencies,
    languages,
    texts,
    taxations,
}: $TSFixMe) => ({
    countries: keyByLodash(countries, 'code'),
    cultureInfos: getCultureInfos(cultureInfos),
    currencies: keyByLodash(currencies, 'code'),
    languages: keyByLodash(languages, 'code'),
    taxRates: getTaxRates(taxations),
    texts,
});

const getCultureInfos = (cultureInfos: $TSFixMe) =>
    mapValues(cultureInfos, ({ code, currency, dateTime, number }) => {
        const {
            shortDateFormat: dateShortFormat,
            dateShortMonthDayFormat,
            longDateFormat: dateLongFormat,
            shortTimeFormat: timeShortFormat,
            firstDayOfWeek,
            has24HourFormat,
            meridiem: [anteMeridiem, postMeridiem],
            dateFormat,
            dateTimeFormat,
            timeFormat,
        } = dateTime;

        return {
            code,
            number,
            currency,
            dateTime: {
                dateFormat,
                dateShortFormat,
                dateShortMonthDayFormat,
                dateLongFormat,
                timeFormat,
                timeShortFormat,
                dateTimeFormat,
                weekStart: Day.getByValue(firstDayOfWeek)?.name,
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                hourFormat: has24HourFormat ? 'TwentyFour' : 'Twelve',
                anteMeridiem,
                postMeridiem,
            },
        };
    });

const getTaxationRates = (taxation: $TSFixMe) =>
    map(
        (taxRate) => ({
            // @ts-expect-error $TSFixMeError: Spread types may only be created from object types.
            ...taxRate,
            taxationCode: taxation.code,
            name: taxation.name,
            localName: taxation.localName,
        }),
        get('taxRates', taxation)
    );

export const getTaxRates = flow(flatMap(getTaxationRates), keyBy('code'));
